import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PROVIDED_JOB_POST_LISTS_QUERY_KEY } from './useProvidedJobPostLists';
import { PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY } from './useProvidedJobPostListShow';

type RemoveItemsParams = {
  listId: string;
  providedJobPostIds: number[];
};

export default function useRemoveItemsFromList() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ listId, providedJobPostIds }: RemoveItemsParams) => {
      const csrfToken =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
      const response = await fetch(
        `/agent/api/provided_job_post_lists/${listId}/remove_items.json`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken,
          },
          body: JSON.stringify({ provided_job_post_ids: providedJobPostIds }),
        }
      );
      if (!response.ok) {
        let errorMessage = 'Failed to remove items from list';
        try {
          const error = await response.json();
          errorMessage = error.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }
      return response.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [PROVIDED_JOB_POST_LISTS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY, variables.listId],
      });
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/provided_job_posts'],
        exact: false,
      });
    },
  });
}
